import "invokers-polyfill";
import "scrollyfills";

if (!HTMLElement.prototype.hasOwnProperty("openable")) {
  Object.defineProperty(HTMLElement.prototype, "openable", {
    get() {
      return this.hasAttribute("openable");
    },
    set(value) {
      if (value) {
        this.setAttribute("openable", "");
      } else {
        this.removeAttribute("openable");
      }
    }
  });

  HTMLElement.prototype.openOpenable = function() {
    this.setAttribute("open", "");
  };
  HTMLElement.prototype.closeOpenable = function() {
    this.removeAttribute("open");
  };
  HTMLElement.prototype.toggleOpenable = function() {
    this.toggleAttribute("open");
  };

  const commands = {
    "open-openable": "openOpenable",
    "close-openable": "closeOpenable",
    "toggle-openable": "toggleOpenable",
  }

  for (const openable of document.querySelectorAll("[openable]")) {
    const id = openable.id;
    if (!id) {
      continue;
    }
    const invokers = document.querySelectorAll(`[commandfor="${id}"]`);
    // Triggers command event on the openable when invokers are clicked.
    for (const invoker of invokers) {
      const command = invoker.getAttribute("command");
      
      // Click event happens first.
      invoker.addEventListener("click", (event) => {
        const commandEvent = new CommandEvent("command", {
          command,
          source: invoker,
          target: openable,
        });

        const oldState = openable.hasAttribute("open") ? "open" : "closed";

        // If the `command` event is canceled, do not proceed with default action.
        if (!openable.dispatchEvent(commandEvent)) {
          return;
        }

        const newState = openable.hasAttribute("open") ? "open" : "closed";

        let toggleEvent = new ToggleEvent("beforetoggle", {
          newState,
          oldState,
          source: invoker,
          target: openable,
        });

        // If `beforetoggle` event is canceled, do not toggle.
        if (!openable.dispatchEvent(toggleEvent)) {
          return;
        }

        // Executes the command action.
        openable[commands[command]]?.();

        toggleEvent = new ToggleEvent("toggle", {
          newState,
          oldState,
          source: invoker,
          target: openable,
        });

        // Asynchronously dispatches the `toggle` event after state has changed.
        openable.dispatchEvent(toggleEvent);
      });

      openable.addEventListener("toggle", () => {
        const expanded = openable.hasAttribute("open");
        invoker.setAttribute("aria-expanded", `${expanded}`);
      });
    }
  }
}

// Polyfills `Math.clamp`
if (typeof Math.clamp !== "function") {
  Math.clamp = function(x, lower, upper) {
    return Math.min(Math.max(x, lower), upper);
  }
}
